import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import Banner from "./banner.jpg";
import Logo from "./logo.png";

export const Header = () => (
  <Container fluid>
    <Row >

      <Col>
      <a className={'logo'} href="https://automobili-pininfarina.com/">
        <img
            className="preload-me"
            src={Logo}
            width="250px"
            height="100%"
            alt="PininFarina"
        />
      </a>

      </Col>
      <img className={'header-image'} src={Banner} width="100%" />
    </Row>
    <Row className="hero">

      <div className="intro">
        <h1 className="heading-1">Geneva Motor Show 2020</h1>

        <p>
          Automobili Pininfarina is celebrating the world premiere of the
          Battista Anniversario at the 2020 Geneva International Motor Show.
          Battista Anniversario was created as a tribute to the iconic designer
          'Battista Pinin Farina' in the 90th anniversary year of the
          Pininfarina design company. Only five Battista Anniversario
          pure-electric hypercars will ever exist. Please visit the Automobili
          Pininfarina stand at Geneva International Motor Show in{' '}
          <strong>Hall 1, Stand 1243</strong>. You are invited to register via
          the following form:
        </p>
      </div>
    </Row>

  </Container>

)

export default Header
